import { factoryService } from '@chilecompra/react-kit/requests'
import { getAuthToken } from '../../services/auth'

/**
 * Factory to create a wrapper to call services and recall them when fail their authorization.
 *
 * Generate a wrapper with the following signature:
 *
 *  interface Args {
 *    [key: string]: any;
 *  }
 *  interface Response {
 *    data: object;
 *    headers: object;
 *    request: object;
 *    status: number;
 *  }
 *
 *  type ServiceAuthWrapper = (args: Args) => Promise<Response>
 *
 * E.g.
 *
 *  getAuthService({ id: 2, ... })
 */
const factoryAuthService = callback => {
  const service = factoryService(callback)

  return args =>
    service(args).catch(error => {
      if (error?.code !== 401) {
        throw error
      }

      return getAuthToken().then(() => service(args))
    })
}

export default factoryAuthService
